import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanLoad, Route, Router, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService }      from '../authentication/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CheckpublicGuard implements CanActivate, CanActivateChild, CanLoad {
  
  constructor(
    private authService: AuthService, 
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let url: string = state.url;
    return this.checkLogin(url);
  }
  
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

  private checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn()){ 
      
      if(localStorage.getItem('has_onboarded') == "true"){
        this.router.navigate(['/admin']);
      }else{
        this.router.navigate(['/onboarding']);
      }
      return false;
    }
    else{
      return true;
    }
  }
}
